import logo from "./logo.svg";
import "./App.css";
import { useState, useEffect, useRef } from "react";
import { Routes, Route, Navigate,useLocation  } from "react-router-dom";
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Blog from "./Components/Blog/Blog";
import Contact from "./Components/Contact/Contact";
import Courses from "./Components/Courses/Courses";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Blog1 from "./Components/Blog/Blog1";
import Blog2 from "./Components/Blog/Blog2";
import Blog3 from "./Components/Blog/Blog3";
import Blog4 from "./Components/Blog/Blog4";
import Login from "./Components/Login/Login";
import Register from "./Components/Register/Register";
import CourseList from "./Components/Courses/CourseList";
import CourseDetails from "./Components/Courses/CourseDetails";
import CourseLec from "./Components/Courses/CourseLec";
import ShowLessons from "./Components/Courses/ShowLessons";
import Terms from "./Components/Terms/Terms";
import Profile from "./Components/Profile/Profile";
import Adver from './Components/Adver/Adver'
import QBank from './Components/QBank/QBank';
import QBankAdver from "./Components/Adver/QBankAdver";
import Verfication from "./Components/Courses/Verfication";
// import { useLocation } from "react-router-dom";
import axios from "axios";
import CustomFooter from "./Components/Footer/CustomFooter";
import RegisterFooter from "./Components/Footer/RegisterFooter";
import { MediaContextProvider } from "./MediaContext";

function App() {
  const [pass, setPass] = useState("");
  const [username, setUsername] = useState("");
  const [user, setUser] = useState("");
  const [lastLocation, setLastLocation] = useState("");
  const location = useLocation()
  const user_id = sessionStorage.getItem('user_id');
  // const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const isRegisterPage = location.pathname === '/register';
  useEffect(() => {

    if (user_id !== null && !isNaN(user_id)) {
      // call the API with user_id
      axios.get(`https://maps-medics-be.onrender.com/check_log/${user_id}` + "/" +
        sessionStorage.getItem("token"))
        .then(response => {
          // handle the API response
          console.log(response.data.success);
          if (response.data.success === false) {
            sessionStorage.clear();
            sessionStorage.clear();

            Navigate('/')

          }
          else {
            console.log('false');

          }
        })
        .catch(error => {
          // handle API errors

          console.error(error);
        });
    } else {
      // clear the sessionStorage if user_id is null or not a number
      sessionStorage.clear()

      // window.location.reload()

    }


  }, []);
  useEffect(() => {
    console.log(lastLocation)
    console.log(location)
    if (lastLocation.includes("courseList")) {
      console.log(location.pathname !== lastLocation)
      if (location.pathname !== lastLocation) {
        const checked = window.confirm("Do you want to leave this page?");
        console.log("before checked")
        if (checked) {
          let locSplit = lastLocation.split("/")
          let real_id = locSplit[locSplit.length - 1]
          console.log("checked")
          const currentTime = sessionStorage.getItem("progress")
          console.log(currentTime)
          if (currentTime) {
            axios.post(
              `https://maps-medics-be.onrender.com/read_lesson/${real_id}/${sessionStorage.getItem("user_id")}`, { duration: currentTime }
            );
          }
        }
      }
    }
    setLastLocation(location.pathname)

  }, [location]);
  function ProtectedRoute({ children }) {
    if (!sessionStorage.getItem("token")) {
      return <Navigate to="/login" />;
    } else {
      return children;
    }
  }
  return (
    <>
      <div className="wrapwrap">
        <div className="main-wrapper">
          <Navbar pass={pass} username={username} user={user} />
<MediaContextProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/terms" element={<Terms />} />
            <Route path='qBank' element={<QBank pass={pass} username={username} />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/blog1" element={<Blog1 />} />
            <Route path="/blog2" element={<Blog2 />} />
            <Route path="/blog3" element={<Blog3 />} />
            <Route path="/blog4/:id" element={<Blog4 />} />
            <Route path='/adver/:id' element={<Adver />} />
            <Route path='/adver' element={<Adver />} />
            <Route path="/register" element={<Register />} />

            {/* <Route path='/verfication' element={<Verfication/>}/> */}

            <Route path='/QBankAdver' element={<QBankAdver pass={pass} username={username} />} />

            {!sessionStorage.getItem("loggedIn") && (
              <Route
                path="/login"
                element={
                  <Login
                    setPassMain={setPass}
                    setUsernameMain={setUsername}
                    setUserMain={setUser}
                  />
                }
              />
            )}
            {sessionStorage.getItem("loggedIn") && (
              <Route path="/profile" element={<Profile />} />
            )}
            <Route path="/profile" element={<Profile userMain={user} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/courseList/:id/:real_id" element={
             <ProtectedRoute> 
            <CourseList />
            </ProtectedRoute>
            } /> 
               <Route path="/courseDetails/:id" element={ <ProtectedRoute> <CourseDetails /></ProtectedRoute>} />
                 <Route path="/courseLec/:id" element={<ProtectedRoute> <CourseLec /></ProtectedRoute>} />
              <Route path="/courseLesson/:real_id" element={ <ProtectedRoute><ShowLessons /></ProtectedRoute>} />
          </Routes>
          </MediaContextProvider>
          {isLoginPage && (
            ''
            // <CustomFooter/>
          )}

          {isRegisterPage && (

''           )}

          {!isLoginPage && !isRegisterPage && (
            <Footer pass={pass} username={username} /> 
          )}
          {/* <Footer pass={pass} username={username} /> */}
        </div>
      </div>
    </>
  );
}

export default App;
